/**
 * Component - promoText
 */

export const promoText = ():void => {
  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-promoText') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {

  })
}
